<template>
  <div id="Training" :class="{completed: isTrainingCompleted}">

    <template v-if="!isTrainingCompleted && ready">
      <LoginTop v-if="!isTrainingCompleted"></LoginTop>

      <div class="card">
        <div class="progress-bar">
          <div class="steps">
            <div class="step" :class="{completed: isPageCompleted(0)}">{{$t('training.steps.navigation')}}</div>
            <div class="step" :class="{completed: isPageCompleted(1)}">{{$t('training.steps.configuration')}}</div>
            <div class="step" :class="{completed: isPageCompleted(2)}">{{$t('training.steps.inventory')}}</div>
            <div class="step" :class="{completed: isPageCompleted(3)}">{{$t('training.steps.marketing')}}</div>
            <div class="step" :class="{completed: isPageCompleted(4)}">{{$t('training.steps.synchronization')}}</div>
          </div>
        </div>
        <div class="card-content">
          <div class="left">
            <template v-if="currentPage">
              <div class="title">{{$t(currentPage.translationKey +'.title')}}</div>
              <div class="details">
                <div>{{$t(currentPage.translationKey +'.body')}}</div>
                <ul class="items">
                  <li v-for="bullet of currentLocalizedBulletPoints">{{bullet}}</li>
                </ul>
              </div>
            </template>

          </div>
          <div class="right" v-if="currentPage">
            <template v-if="!isFinalPageOrUp">
              <span class="title">{{$t("training.video_title")}}</span>
              <div class="player">
                <template v-if="currentLocalizedVideo">
                  <iframe width="360" height="202.5" :src="currentLocalizedVideo"
                          title="YouTube video player" frameborder="0" allow="accelerometer; autoplay;
                          clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </template>
              </div>
              <div class="confirmation group" :class="{locked: !!isTrainingCompleted || currentPage.confirmed}">
                <input id="chkQuantifiable" type="checkbox" v-model="currentPage.confirmed" :disabled="!!isTrainingCompleted" :readonly="!!isTrainingCompleted">
                <label for="chkQuantifiable">{{$t('training.confirmed')}}</label>
              </div>
            </template>
            <template v-if="isFinalPageOrUp">
              <div class="image"></div>
            </template>
          </div>
        </div>
        <div class="buttons">
          <div class="filler" v-if="isFirstPage"></div>
          <button class="btn btn-secondary back" @click="back" v-if="!isFirstPage">
            <svgicon src="/icon/arrow-right.svg" height="25" width="25"></svgicon>
            {{$t('back')}}
          </button>
          <button class="btn btn-primary" @click="next" v-if="!isFinalPageOrUp">
            {{$t('next')}}
            <svgicon src="/icon/arrow-right.svg" height="25" width="25"></svgicon>
          </button>
          <button class="btn btn-primary" @click="finish" v-if="isFinalPageOrUp">
            {{$t('done')}}
            <svgicon src="/icon/arrow-right.svg" height="25" width="25"></svgicon>
          </button>
        </div>
      </div>

      <div class="buttons skip">
        <button class="btn btn-primary" @click="pushDefaultRoute">
          {{$t('training.skip')}}
          <svgicon src="/icon/arrow-right.svg" height="25" width="25"></svgicon>
        </button>
      </div>

      <LoginBottom v-if="!isTrainingCompleted"/>
    </template >
    <template v-if="isTrainingCompleted && ready">
      <panel class="completed" v-for="page in pages" :prefix="'0' + (page.pageIndex + 1) + '. '" :title="$t(page.translationKey + '.title')"
             v-bind:key="page.pageIndex" v-if="page.pageIndex < (pages.length - 1)" collapsible>
        <div class="card-content">
          <div class="left">
            <div class="details">
              <div>{{$t(page.translationKey +'.body')}}</div>
              <ul class="items">
                <li v-for="bullet of $t(page.translationKey + '.bullet_points')">{{bullet}}</li>
              </ul>
            </div>
            <div class="faq">
              <button class="btn btn-primary" @click="openSupportUrl()">
                {{$t('training.faq')}}
              </button>
            </div>
          </div>
          <div class="right">
            <template v-if="">
              <span class="title">{{$t("training.video_title")}}</span>
              <div class="player">
                <template>
                  <iframe width="470" height="265" :src="localizeVideo(page.video)"
                          title="YouTube video player" frameborder="0" allow="accelerometer; autoplay;
                          clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </template>
              </div>
            </template>
          </div>
        </div>
      </panel>
    </template>

  </div>
</template>

<script>
  import { Core } from '@/core/Core';
  import LoginTop from "@/components/login/Top.vue";
  import LoginBottom from "@/components/login/Bottom.vue";

  export default {
    name: "Training",

    components: {LoginTop, LoginBottom},

    data() {
      return {
        Parameters,
        ready: false,
        termsId: "video_training",
        isTrainingCompleted: null,
        currentPageIndex: 0,
        pages: [
          {
            pageIndex: 0,
            video: {
              fr: "https://www.youtube.com/embed/ZtM8x2X9M5U?rel=0",
              en: "https://www.youtube.com/embed/AQ84ZH-RqIU?rel=0"
            },
            translationKey: "training.first_page",
            confirmed: false
          },
          {
            pageIndex: 1,
            video: {
              fr: "https://www.youtube.com/embed/avE6PnPMM0Y?rel=0",
              en: "https://www.youtube.com/embed/bEk4EhAKmLQ?rel=0",
            },
            translationKey: "training.second_page",
            confirmed: false
          },
          {
            pageIndex: 2,
            video: {
              fr: "https://www.youtube.com/embed/6Py8ZIhPFIk?rel=0",
              en: "https://www.youtube.com/embed/mSavtV2glCE?rel=0",
            },
            translationKey: "training.third_page",
            confirmed: false
          },
          {
            pageIndex: 3,
            video: {
              fr: "https://www.youtube.com/embed/l9HriKkpgZ0?rel=0",
              en: "https://www.youtube.com/embed/POMqmhhIzjo?rel=0",
            },
            translationKey: "training.fourth_page",
            confirmed: false
          },
          {
            pageIndex: 4,
            video: {
              fr: "https://www.youtube.com/embed/d0y7sEwEvW4?rel=0",
              en: "https://www.youtube.com/embed/sMTPoLjT5fs?rel=0",
            },
            translationKey: "training.fifth_page",
            confirmed: false
          },
          {
            pageIndex: 5,
            translationKey: "training.final_page",
          }
        ],
      }
    },

    computed: {
      currentPage() {
        return this.pages[this.currentPageIndex];
      },
      currentLocalizedVideo() {
        if (this.currentPage) {
          return this.localizeVideo(this.currentPage.video);
        }
        return "";
      },
      currentLocalizedBulletPoints() {
        if (this.currentPage && this.currentPage.translationKey) {
          return this.$t(this.currentPage.translationKey + '.bullet_points');
        }
        return [];
      },
      isFinalPageOrUp() {
        return this.currentPageIndex >= (this.pages.length - 1);
      },
      isFirstPage() {
        if (this.pages.length > 0 ) {
          return this.currentPageIndex == this.pages[0].pageIndex;
        }
        return true;
      },
      isLoggedUserBranchAdmin() {
        return this.$store.state.loggedUser.isBranchAdmin;
      },
      isLoggedUserCompanyAdmin() {
       return this.$store.state.loggedUser.isCompanyAdmin;
      },
      loggedUserHasRightContext() {
        if (this.isLoggedUserBranchAdmin) {
          return !!this.$route.query.branch;
        }
        else if (this.isLoggedUserCompanyAdmin) {
          return !!this.$route.query.company && !!this.$route.query.branch;
        }
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "training.title";
      this.$store.state.pageIcon = "/icon/info.svg";
      if (!this.loggedUserHasRightContext) {
        this.addContextToRoute();
      }
      if (typeof this.$store.state.loggedUser.trainingCompleted === 'undefined') {
        await this.verifyTrainingConfirmation();
      }
      this.ready = true;
      this.isTrainingCompleted = this.$store.state.loggedUser.trainingCompleted;
      if (this.isTrainingCompleted) {
        this.$store.commit("setHeaderMenuVisible", true);
      }
    },

    methods: {
      next() {
        if (!this.isFinalPageOrUp) {
          if (!this.currentPage.confirmed) {
            toast(this.$t("training.warning_confirm"), "error");
            return;
          }
          this.currentPageIndex++;
          document.getElementById("Training").scrollTop = 0;
        }
      },
      back() {
        if (this.currentPageIndex > 0) {
          this.currentPageIndex--;
        }
        document.getElementById("Training").scrollTop = 0;
      },
      isPageCompleted(index) {
        if (this.pages.length > 0 && this.pages.length > index) {
          return this.pages[index].confirmed;
        }
        return false;
      },
      async finish() {
        if (!this.isTrainingCompleted) {
          await this.submitTrainingConfirmation();
        }
        this.pushDefaultRoute();
      },
      async submitTrainingConfirmation() {
        showSpinner();
        try {
          let response = await Core.request('POST', '/api/terms/' + this.termsId + '/accept');
          if (response) {
            this.$store.state.loggedUser.trainingCompleted = true;
          } else {
            toast(this.$t("error.no_server"), "error");
            console.log(response);
          }
        } catch (e) {
          toast(this.$t("error.no_server"), "error");
          console.log(e);
          hideSpinner();
        }
        hideSpinner();
      },
      async verifyTrainingConfirmation() {
        try {
          showSpinner();
          let response = await Core.request('GET', '/api/me/terms_agreements', {termsId: this.termsId});
          if (response && response.data) {
            this.$store.state.loggedUser.trainingCompleted = !!response.data[0];
          } else {
            this.$store.state.loggedUser.trainingCompleted = false;
            toast(this.$t("error.no_server"), "error");
            console.log(response);
          }
        } catch (e) {
          this.$store.state.loggedUser.trainingCompleted = false;
          toast(this.$t("error.no_server"), "error");
          console.log(e);
          hideSpinner();
        }
        hideSpinner();
      },
      localizeVideo(video) {
        if (video) {
          return this.$to(video);
        }
        return "";
      },
      openSupportUrl() {
        window.open(this.$to(Parameters.urlSupport), '_blank');
      },
      async addContextToRoute() {
        let user = this.$store.state.loggedUser;
        let branch = user.branch || undefined;
        let company = user.company || undefined;
        //TODO est ce que ici je devrais fait un this.$router.buildContext avant ma redirection si le data est pas loaded
        //Tu as pas besoin parce que tu prend juste l'ID qui est dans le user, on dont care à propos du data
        if (this.isLoggedUserBranchAdmin) {
          await this.$router.replace("/training?branch=" + branch);
          return;
        }
        if (this.isLoggedUserCompanyAdmin) {
          await this.$router.replace("/training?branch=" + branch + "&company=" + company);
        }

      },
      async pushDefaultRoute() {
        let defaultRoute = this.$store.getters.defaultRouting;
        if (defaultRoute) {
          await this.$router.push(defaultRoute);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  $transition-delay: 300ms;

  #Training {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    scroll-behavior: smooth;
    padding: 0;

    &.completed {
      padding: 40px;
      .card {
        .card-content {
          padding: 0;
          .details {
            border: none;
          }

          .right {
            padding-top: 0;
          }
        }
      }
    }
  }

  .panel.completed {
    max-width: 1040px;
    align-self: center;
    width: 100%;
    border-radius: 10px;
    box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.1);
    .card-content {
      padding: 0;
      .details {
        border: none;
      }
      .left {
        padding-top: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .faq {
          padding-bottom: 10px;
          &.top {
            display: block;
          }
          &.bottom {
            display: none;
          }
        }

      }
      .right {
        padding-top: 0;
      }
    }
  }

  .card {
    align-self: center;
    display: flex;
    flex-wrap: wrap;
    box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.1);
    border-radius: 40px;
    background-color: #ffffff;
    max-width: 900px;
    padding: 60px;
  }

  .progress-bar {
    z-index: 1;
    flex-grow: 1;
    .steps {
      display: flex;
      counter-reset: step;

      .step {
        flex-grow: 1;
        flex-basis: 0;
        position: relative;
        text-align: center;
        color:  #bfbfbf;
        font-size: 12px;
        &::before {
          transition: all $transition-delay ease-in-out $transition-delay;
          display: flex;
          align-items: center;
          justify-content: center;
          content: counter(step);
          counter-increment: step;
          width: 28px;
          height: 28px;
          font-size: 16px;
          font-weight: 900;
          border: solid 4px #d9d9d9;
          margin: 0 auto 10px auto;
          border-radius: 50%;
          line-height: 31px;
          background-color: #ffffff;
          color: #d9d9d9;
          text-align: center;
        }

        &::after {
          content: '';
          position: absolute;
          width: 100%;
          height: 4px;
          top: 17px;
          left: -50%;
          z-index: -1;
          background: linear-gradient(to left, #d9d9d9 50%, #fc6650 50%) right;
          background-size: 200%;
          transition: $transition-delay ease-out;
        }
        &:first-child::after {
          content: none;
        }

        &.completed {
          color:  #fc6650;
          transition: color $transition-delay ease-in-out $transition-delay;
          &::before {
            content: counter(step);
            counter-increment: step;
            background-image: url('~@/../public/icon/checkmark-white.svg');
            background-repeat: no-repeat;
            background-size: 15px 15px;
            background-position: center center;
            background-color: #fc6650;
            border-color: #fc6650;
            color: rgba(252, 102, 80, 0);
          }
          &::after {
            background-position: left;
          }
        }
      }
    }
  }

  .card-content {
    padding: 30px 0;
    display: flex;
    flex-grow: 1;
    flex-wrap: wrap;
    .left, .right {
      flex-grow: 1;
      flex-basis: 0;
      min-width: 240px;
    }
    .left {
      padding-right: 30px;
      .title {
        padding: 15px 0;
        font-size: 20px;
        font-weight: bold;
        color: #ed2937;
      }
      .details {
        border-top: 1px dashed #e6e6e6;
        padding-top: 10px;
        color: #404040;
        .items {
          list-style: none;
          padding: 0;
          & > li {
            position: relative;
            padding-left: 30px;
            padding-top: 5px;
            &::before {
              content: "\2022";
              font-size: 36px;
              position: absolute;
              left: 5px;
              top: -7px;
              color: #ed2937;
              @media (max-width: 550px) {
                font-size: 28px;
                top: -4px;
              }
            }
          }
        }
      }
    }

    .right {
      padding-left: 30px;
      padding-top: 15px;
      .title {
        color: #808080;
      }
      .player {
        margin: 10px 0;
        border-radius: 5px;
        overflow: hidden;
        z-index: 1;
      }
      .confirmation {
        padding-top: 15px;
      }
      .image {
        width: 360px;
        height: 270px;
        background-image: url('~@/../public/img/formation-end.jpg');
      }
    }
  }

  .buttons {
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
  }

  .footer {
    position: absolute;
  }

  @media (max-width: 550px) {
    #Training, #Training.completed {
      padding: 20px 10px;
    }

    #Training {
      .panel.completed .card-content {
        font-size: 15px;
        .left {
          padding: 0;
        }

        .right {
          padding: 25px 0 0 0 ;
          .title {
            font-size: 14px;
          }
        }

        .faq {
          &.top {
            display: none;
          }
          &.bottom {
            display: block;
          }
          .btn {
            font-size: 15px;
            width: 100%;
          }
        }
      }
    }
  }

</style>

<style lang="scss">
  #Training {
    .card-content .right .player {
      position: relative;
      padding-bottom: 56.25%; /* 16:9 */
      height: 0;
      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }

    .btn.back {
      background-color: #ffffff;
    }

    .buttons .btn {
      position: relative;
      .svgicon {
        position: absolute;
        top: 50%;
      }
      &.btn-primary {
        padding-right: 30px;
        .svgicon {
          right: 0;
          transform: translateY(-50%);
          fill: #ffffff;
        }
      }
      &.btn-secondary {
        padding-left: 30px;
        .svgicon {
          left: 0;
          transform: translateY(-50%) rotate(180deg);
          fill: #fc6650;
        }
      }
    }

    .skip {
      flex-grow: 0;
      justify-content: center;
    }

    .panel .prefix {
      color: #ed2937;
    }
  }
</style>

<style lang="scss">
  #Training.mobile:not(.completed) {
    padding: 0;
    height: 100%;

    #loginTop {
      height: 70px;
      background-color: white;
      flex-shrink: 0;

      img {
        max-width: 50%;
        height: auto;
      }
    }
    .card {
      box-shadow: none;
      padding: 15px 20px;
      border-radius: 0;
    }
    .progress-bar {
      .steps {
        .step {
          font-size: 11px;
        }
      }
    }
    .left {
      padding-right: 0;
    }
    .left .title {
      padding-top: 0;
      font-size: 18px;
    }
    .right {
      padding-left: 0;
    }
    .buttons.skip {
      padding: 30px 0;
    }
    .btn {
      font-size: 14px;
    }
  }
</style>